'use client';

import { identifyUser, setWorkspaceGroup } from '@/external/posthog/client';
import { type FunctionComponent, useEffect } from 'react';

interface Props {
  userId: string;
  email: string;
  name: string | null;
  role: string;
  workspaceId: string;
  workspaceName: string;
  workspaceSlug: string;
  isKpc: boolean;
}

// Mount once in the root layout (server component passes session data as props)
// to tie session replays and events to the signed-in user, and to the workspace
// group so every event this browser sends is filterable by tenant.
const PostHogUserInit: FunctionComponent<Props> = ({
  userId,
  email,
  name,
  role,
  workspaceId,
  workspaceName,
  workspaceSlug,
  isKpc,
}) => {
  useEffect(() => {
    identifyUser({ userId, email, name, role });
    setWorkspaceGroup({ id: workspaceId, name: workspaceName, slug: workspaceSlug, isKpc });
  }, [userId, email, name, role, workspaceId, workspaceName, workspaceSlug, isKpc]);
  return null;
};

export default PostHogUserInit;
